import { useEffect, useMemo, useState } from 'react';
import { OrbitControls, OrthographicCamera } from '@react-three/drei';
import { OrthographicCamera as OrthographicCameraType, Vector3 } from 'three';
import { OrbitControls as OrbitControlsImpl } from 'three-stdlib';
import { useCameraStore } from './useCameraStore';
import { useStandingMeshStore } from '../Standing/standingMeshStore';
interface SyncedCameraControlsProps {
  sourceId: 'primary' | 'secondary';
  makeDefault?: boolean;
}

export const SyncedCameraControls = ({
  sourceId,
  makeDefault = false,
}: SyncedCameraControlsProps) => {
  const [camera, setCamera] = useState<OrthographicCameraType | null>();
  const { standingMeshBoundingBox } = useStandingMeshStore();
  const [cameraControls, setCameraControls] =
    useState<OrbitControlsImpl | null>();
  const { setControls } = useCameraStore();

  const target = useMemo(() => {
    if (!standingMeshBoundingBox) {
      return new Vector3(0, 1, 0);
    }
    const box = standingMeshBoundingBox;
    const center = box.getCenter(new Vector3());
    return center;
  }, [standingMeshBoundingBox]);

  useEffect(() => {
    if (cameraControls) {
      setControls(cameraControls, sourceId);
    }
  }, [cameraControls, sourceId, setControls]);

  // Set initial target when controls are created
  useEffect(() => {
    if (cameraControls && target) {
      cameraControls.target.copy(new Vector3(0, target.y, 0));
      cameraControls.update();
    }
  }, [cameraControls, target]);

  return (
    <>
      <OrthographicCamera
        ref={setCamera}
        makeDefault={makeDefault}
        position={[0, target.y, 2]}
        zoom={300}
        near={-100}
        far={100}
      />
      {camera && (
        <OrbitControls
          camera={camera}
          ref={setCameraControls}
          dampingFactor={0.1}
          enableDamping={true}
          // target={new Vector3(0, target.y, 0)}
        />
      )}
    </>
  );
};
